import { TrendingUp } from "lucide-react";

type Props = {
  industryHint?: string;
};

export function GenericCaseStudyStrip({ industryHint }: Props) {
  const thirdLabel = industryHint
    ? `Colorado Springs ${industryHint}`
    : "Colorado Springs trades co.";

  const cards = [
    {
      result: "4.2× organic leads",
      timeframe: "7 months",
      summary: `Denver HVAC contractor went from page 3 to top-3 Map Pack for "AC repair Denver" and 14 neighborhood variants.`,
    },
    {
      result: "Top-3 for 12 money keywords",
      timeframe: "9 months",
      summary: `Front Range law firm captured first-page rankings for high-intent practice-area + city searches across the metro.`,
    },
    {
      result: "+38% conversion lift",
      timeframe: "60 days post-launch",
      summary: `${thirdLabel} rebuild — same traffic, redesigned for clarity and trust, nearly doubled qualified contact-form submissions.`,
    },
  ];

  return (
    <section className="bg-background py-16 lg:py-20">
      <div className="mx-auto max-w-6xl px-5 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-brand-gold-deep">
            Real results
          </p>
          <h2 className="mt-2 text-3xl font-extrabold tracking-tight text-foreground sm:text-4xl">
            What Colorado businesses see when they work with us
          </h2>
          <p className="mt-3 text-base leading-relaxed text-muted-foreground">
            A snapshot of recent client outcomes. Real numbers, anonymized for privacy.
          </p>
        </div>

        <ul className="mt-10 grid gap-5 md:grid-cols-3">
          {cards.map((c) => (
            <li
              key={c.result}
              className="flex h-full flex-col rounded-2xl border border-border bg-card p-6 shadow-card"
            >
              <div className="flex items-center gap-2 text-brand-gold-deep">
                <TrendingUp className="h-5 w-5" />
                <span className="text-xs font-bold uppercase tracking-[0.15em]">
                  {c.timeframe}
                </span>
              </div>
              <p className="mt-3 text-xl font-extrabold text-foreground">
                {c.result}
              </p>
              <p className="mt-3 text-sm leading-relaxed text-foreground/85">
                {c.summary}
              </p>
            </li>
          ))}
        </ul>

        <p className="mt-6 text-xs text-muted-foreground">
          Real client results, anonymized for privacy. Past performance does not guarantee future results.
        </p>
      </div>
    </section>
  );
}
